<template>
  <div
    class="block rounded shadow-xs border"
    @click="$emit('production-order-item:view', productionOrderItem.uuid)"
    :class="[focus ? 'border-gray-700' : 'border-white']"
  >
    <div class="rounded shadow-md overflow-hidden bg-white text-xs">
      <div v-if="productionOrder.name" class="p-2">
        {{ productionOrder.name }}
      </div>
      <div v-if="project" class="px-2 py-1 text-gray-700 bg-gray-100">
        {{ project.name }}
      </div>
      <div v-if="provider" class="px-2 py-1 text-gray-700 bg-gray-100">
        {{ provider.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductionOrderItemListLine',

  props: {
    id: {
      type: String,
      required: true,
    },
    lastEditedProductionOrderItemId: {
      type: String,
      default: null,
    },
  },

  computed: {
    productionOrder() {
      return this.$store.state.entities.orders.byId[this.id];
    },
    productionOrderItem() {
      if (!this.productionOrder.orderItems) return undefined;
      if (!this.productionOrder.orderItems.length) return undefined;

      return this.$store.state.entities.orderItems.byId[this.productionOrder.orderItems[0]];
    },
    provider() {
      return (
        this.$store.state.entities.accountRelations.byId[this.productionOrder.provider] || null
      );
    },
    project() {
      if (!this.productionOrder.projectUuid) {
        return undefined;
      }

      return this.$store.state.entities.projects.byId[this.productionOrder.projectUuid];
    },
    focus() {
      if (!this.productionOrderItem) {
        return false;
      }

      return this.lastEditedProductionOrderItemId === this.productionOrderItem.uuid;
    },
  },

  watch: {
    productionOrderItem: {
      handler(productionOrderItem, oldProductionOrderItem) {
        this.$emit('production-order-item:updated', {
          productionOrderItem,
          oldProductionOrderItem,
        });
      },
    },
  },
};
</script>
